import * as React from 'react';
import { CustomForm, CustomFormReportData } from '../../../../amorg-common';
import { OnlyOnPrint, PrintStyle } from '../../../../designSystem/compositeComponents/Print';

import { CustomFormFilter } from '../../../../utils/customFormHelper';



type PrintCustomFormReportPageProps = {
    form: CustomForm,
    report:CustomFormReportData,
    filters:CustomFormFilter[],
    innerRef: React.Ref<HTMLDivElement>
}


export function PrintCustomFormReportPage(props:PrintCustomFormReportPageProps):JSX.Element
{
    return (
        <OnlyOnPrint>
            <PrintStyle ref={props.innerRef}>
                Print something

               {props.filters?.map((filter) => {
                    <div key={filter.fieldId}>
                        {filter.label}
                    </div>
               })}
            </PrintStyle>
        </OnlyOnPrint>
        
    );
}




